(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('FileUtil', FileUtil);

    FileUtil.$inject = ['$resource'];

    function FileUtil($resource) {

        var download_uploaded_file = function (request, onSuccess, onError) {

            request.get({}, function (result) {

                var dlfile = "api/downloadUploadedFile/" + result.filename;
                result.dllink = dlfile;
                if (onSuccess) {
                    onSuccess(result);
                }
                setTimeout(function () {
                    document.location.href = dlfile;
                }, 500);


            }, function (error) {
                if (onError)
                    onError(error);
            });
        }

        var downloadFile = function (filename) {
            var resourceUrl = 'api/downloadfile?fileName=' + filename;
            return $resource(resourceUrl, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );
        };

        return {
            downloadFile: downloadFile,
            downloadUploadedFile: download_uploaded_file
        };
    }
})();
